import {Controller} from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {

    static targets() {
        return ['list', 'filters', 'active-filters', 'load-btn'];
    }

    connect() {
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.filters = {};
        this.type = this.element.dataset.type;
        this.from = this.element.dataset.from ? this.element.dataset.from : 0;
        this.limit = this.element.dataset.limit ? this.element.dataset.limit : 8;
        this.total = this.element.dataset.total ? this.element.dataset.total : -1;

        this.handleFilters();

        if (this.element.dataset.filter) {
            this.filters = JSON.parse(this.element.dataset.filter);
        }

        const btn = this.targets.find('load-btn');
        if (btn) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.fetchPosts().then(response => {
                    if (response && response.html) {
                        this.insertContent(response.html);
                        this.from = response.from;
                        this.total = response.total;

                        if (this.total === this.from) {
                            btn.classList.add('hidden');
                        } else {
                            btn.classList.remove('hidden');
                        }
                    }
                });
            });

            if (this.total === this.from) {
                btn.classList.add('hidden');
            } else {
                btn.classList.remove('hidden');
            }
        }
    }

    disconnect() {

    }

    handleFilters() {
        const postFilters = this.targets.find('filters');
        if (postFilters) {
            let timeout = 0;
            postFilters.querySelectorAll('.single-filter').forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();

                    const name = btn.getAttribute('data-taxonomy');
                    this.filters[name] = btn.getAttribute('data-value');

                    postFilters.querySelectorAll('.single-filter').forEach((btn2) => {
                        btn2.classList.remove('active');
                    });

                    btn.classList.add('active');

                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        this.from = 0;
                        this.fetchPosts().then(response => {
                            if (response && response.html) {
                                this.emptyContent();
                                this.insertContent(response.html);
                                this.from = response.from;
                                this.total = response.total;

                                const btn = this.targets.find('load-btn');
                                if (btn) {
                                    if (this.total === this.from) {
                                        btn.classList.add('hidden');
                                    } else {
                                        btn.classList.remove('hidden');
                                    }
                                }
                            }
                        });
                    }, 800);
                });
            });
        }
    }

    async fetchPosts() {
        if (parseInt(this.from) >= parseInt(this.total) && parseInt(this.total) > 0) {
            return '';
        }

        this.element.classList.remove('loading-block-loaded');
        this.element.classList.add('loading-block');

        const data = {
            rest_language: this.currentLanguageCode,
            from: this.from,
            limit: this.limit,
            filters: JSON.stringify(this.filters),
        };

        const params = Object.keys(data).map(function (k) {
            return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
        }).join('&');

        let response = null;
        try {
            response = await Axios.post(`${theme.rest_route}${this.type}`, data);
            response = response.data;
        } catch (error) {
            response = error.response.data.data;
        }

        return response;
    }

    emptyContent() {
        const list = this.targets.find('list');
        if (list) {
            list.innerHTML = '';
        } else {
            this.element.innerHTML = '';
        }
    }

    insertContent(html) {
        const list = this.targets.find('list');
        if (list) {
            list.insertAdjacentHTML('beforeend', html);
        } else {
            this.element.insertAdjacentHTML('beforeend', html);
        }
        this.element.classList.remove('loading-block');
        this.element.classList.add('loading-block-loaded');

        setTimeout(() => this.element.classList.remove('loading-block-loaded'), 1000);
    }
}
